import PropTypes from "prop-types";
import React, { ReactNode } from "react";
import BackButton from "../common/BackButton";
import SubHeader from "../common/SubHeader";

interface IPageLayout {
  children: ReactNode;
  className?: string;
  pageTitle?: string;
}
const PageLayout = ({ children, className, pageTitle }: IPageLayout) => {
  return (
    <div className={`h-full page-content font-transat flex flex-col md:flex-row ${className}`}>
      <div className="block md:hidden">
        <SubHeader title={pageTitle} />
      </div>
      <div className="tailwind-hidden md:block my-6 mx-3">
        <BackButton />
      </div>
      <div className="px-2 mt-2 md:mt-5 flex-grow max-w-screen-lg mx-auto mb-2">{children}</div>
    </div>
  );
};

PageLayout.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

PageLayout.defaultProps = {
  className: "",
};

export default PageLayout;
